import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = no auth, obj = auth
  const [activeProject, setActiveProjectState] = useState(
    localStorage.getItem("tp_active_project") || null
  );

  const loadMe = async () => {
    const token = localStorage.getItem("tp_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data.project_id) setActiveProject(data.project_id);
    } catch (e) {
      localStorage.removeItem("tp_token");
      setUser(false);
    }
  };

  useEffect(() => {
    loadMe();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("tp_token", data.access_token);
    setUser(data.user);
    if (data.user.project_id) setActiveProject(data.user.project_id);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("tp_token");
    localStorage.removeItem("tp_active_project");
    setActiveProjectState(null);
    setUser(false);
  };

  const setActiveProject = (pid) => {
    if (pid) localStorage.setItem("tp_active_project", pid);
    else localStorage.removeItem("tp_active_project");
    setActiveProjectState(pid);
  };

  return (
    <AuthContext.Provider
      value={{ user, login, logout, activeProject, setActiveProject, reload: loadMe }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
